import JSZip from 'jszip';

const CUSTOM_XML_PATH_PATTERN = /^customXm[lL]\//i;
const CUSTOM_XML_CONTENT_TYPE_PATTERN =
  /<Override[^>]+PartName="\/customXm[lL][^"]*"[^>]*\/>/gi;
const CUSTOM_XML_RELATIONSHIP_PATTERN =
  /<Relationship[^>]+Type="[^"]*\/customXml"[^>]*\/>/gi;

export async function stripCustomXmlParts(zip) {
  Object.keys(zip.files).forEach((name) => {
    if (CUSTOM_XML_PATH_PATTERN.test(name)) {
      zip.remove(name);
    }
  });

  const contentTypesPath = '[Content_Types].xml';
  const contentTypes = await zip.file(contentTypesPath)?.async('string');
  if (contentTypes) {
    zip.file(contentTypesPath, contentTypes.replace(CUSTOM_XML_CONTENT_TYPE_PATTERN, ''), {
      createFolders: false,
    });
  }

  const relsPath = 'word/_rels/document.xml.rels';
  const rels = await zip.file(relsPath)?.async('string');
  if (rels) {
    zip.file(relsPath, rels.replace(CUSTOM_XML_RELATIONSHIP_PATTERN, ''), {
      createFolders: false,
    });
  }

  return zip;
}

export async function sanitizeTermSheetDocxZip(zip) {
  await stripCustomXmlParts(zip);
  return zip;
}

export async function assertNoCustomXmlParts(zip) {
  const customXmlPaths = Object.keys(zip.files).filter((name) =>
    CUSTOM_XML_PATH_PATTERN.test(name)
  );
  if (customXmlPaths.length > 0) {
    throw new Error(`customXml parts remain in docx: ${customXmlPaths.join(', ')}`);
  }

  const rels = await zip.file('word/_rels/document.xml.rels')?.async('string');
  if (rels?.includes('/customXml')) {
    throw new Error('document.xml.rels still references customXml');
  }
}
